const config = {
  // 开发
  // dc: 'https://demo.dc.api.dianzhangbao.net/v1/',
  // dc_v2: 'https://demo.dc.api.dianzhangbao.net/v2/',

  // // 开发域名
  // dc_domain: 'https://demo.dc.api.dianzhangbao.net/',

  // img_baseurl: 'https://demo.dc.api.dianzhangbao.net',

  // // pc地址
  // pc_url: 'https://demo.diancan.dianzhangbao.net',

  // ---------------------------------------------------------------------

  // 灰度
  // dc: 'https://dctest.api.dianzhangbao.com.cn/v1/',
  // dc_v2: 'https://dctest.api.dianzhangbao.com.cn/v2/',

  // // 灰度域名
  // dc_domain: 'https://dctest.api.dianzhangbao.com.cn/',

  // img_baseurl: 'https://dctest.api.dianzhangbao.com.cn',

  // // pc地址
  // pc_url: 'https://dctest.pc.dianzhangbao.com.cn',

  // ---------------------------------------------------------------------

  // 正式版新域名
  // 服务器一：diancan.api.dianzhangbao.com.cn，小程序+服务员端接口
  // 服务器二：diancan.api2.dianzhangbao.com.cn，安卓收银端接口
  // 静态图片地址+CDN： img2.dianzhangbao.com.cn
  dc: 'https://diancan.api2.dianzhangbao.com.cn/v1/',
  dc_v2: 'https://diancan.api2.dianzhangbao.com.cn/v2/',

  dc_domain: 'https://diancan.api2.dianzhangbao.com.cn/',

  img_baseurl: 'https://img2.dianzhangbao.com.cn',

  // pc地址
  pc_url: 'https://diancan.pc2.dianzhangbao.com.cn',

  // ---------------------------------------------------------------------

  // Windows安装包调用
  netUrl: 'http://localhost:3001/',

  // socket
  // socket_url: 'https://dcserver.dianzhangbao.net/',
  socket_url: 'https://dcserver.dianzhangbao.com.cn/', // 正式版新域名
}

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./configapi.js
// module id = tosy
// module chunks = 48